import { render, staticRenderFns } from "./cashbooks.vue?vue&type=template&id=05a393d0&scoped=true&"
import script from "./cashbooks.vue?vue&type=script&lang=js&"
export * from "./cashbooks.vue?vue&type=script&lang=js&"
import style0 from "./cashbooks.vue?vue&type=style&index=0&id=05a393d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a393d0",
  null
  
)

export default component.exports